import React from 'react'
import CustomerContainer from '../../containers/admin_portal/customer';
const CustomerPage = () => {
  return (
    <div>
      <CustomerContainer/>
    </div>
  )
}

export default CustomerPage;
